import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/guessbtc/Ticker_arrow_up.png")